var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamlarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.16 8.23a4.2 4.2 0 1 1-8.42 0 4.2 4.2 0 1 1 8.42 0ZM11.95 20c-3.43 0-6.36-.54-6.36-2.72s2.9-2.74 6.36-2.74c3.43 0 6.36.54 6.36 2.72S15.4 20 11.95 20Zm6-11.7c0 1.2-.35 2.32-.98 3.25-.06.1 0 .22.11.24a3.51 3.51 0 0 0 4-2.57 3.58 3.58 0 0 0-4.12-4.44c-.04 0-.07.02-.09.05-.02.03 0 .08.02.1a5.8 5.8 0 0 1 1.07 3.38Zm2.73 5.21c1.1.22 1.83.66 2.13 1.3.25.54.25 1.15 0 1.68-.46 1-1.94 1.32-2.52 1.4-.12.02-.22-.09-.2-.2.3-2.77-2.05-4.09-2.66-4.39-.02-.01-.03-.03-.03-.05l.04-.02c1.3-.03 2.72.15 3.24.28ZM6.44 11.84c.16 0 .32-.02.48-.05a.16.16 0 0 0 .1-.24 5.8 5.8 0 0 1 .08-6.61c.03-.03.05-.08.03-.11-.02-.03-.05-.04-.08-.05a3.57 3.57 0 1 0-.6 7.06Zm.16 1.41c0 .02 0 .04-.03.05-.6.3-2.95 1.62-2.66 4.38.02.12-.08.23-.2.2-.57-.07-2.06-.4-2.52-1.4a1.92 1.92 0 0 1 0-1.66c.3-.65 1.03-1.09 2.13-1.3a15.64 15.64 0 0 1 3.28-.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamlarge);
export default __webpack_public_path__ + "static/media/team.large.795217a7dbd78e068b17659c20512524.svg";
export { ForwardRef as ReactComponent };